<template>
    <div>
        <v-container v-if="getloading" style="height: 450px;">
            <v-row
                class="fill-height"
                align-content="center"
                justify="center"
            >
                <v-col cols="8" class="text-subtitle-1 text-center">
                    <v-card elevation="0">
                        <span>
                            Getting your Net Bill...
                        </span><br /><br />
                        <v-progress-linear
                            color="#80DEEA"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-row justify="center" v-else>
            <v-card elevation="0" v-if="!errorFlag">
                <v-card-text>
                    <!--Header-->
                    <v-row>
                        <img src="../../../assets/backgrounds/kings_logo.jpg" width="152" id="kingslogo" />
                        <span style="font-size: 13px; padding-left: 10px;">
                            <br />
                            King's University College <br />
                            266 Epworth Avenue London, ON <br />
                            N6A 2M3
                        </span>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <div style="color: black;">
                        <b>{{ getUserName }} &#40;{{ getStudentNo }}&#41; </b><br />
                        Date Created: <b>{{ studentNetBillData["generatedDate"] }}</b> <br />
                        Current Study Period: <b>{{ studentNetBillData['applicant-studyperiodstart']+'-'+studentNetBillData['applicant-studyperiodend']  }}</b>
                    </div>
                    <!--Table(s)-->
                    <v-row v-if="secondInstallment">
                        <v-col>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <!--Year is to be entered from data-->
                                        <tr><th class="text-left" colspan="2" style="font-size: 13px;">Net Tuition Bill - First Installment of {{ studentNetBillData['academicyear'] }}</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="item in winter_first_column"
                                            :key="item.text"
                                        >
                                        <td v-html="item.text"></td>
                                        <td> 
                                            <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] > 0">${{ studentNetBillData[item.value] }}</span>
                                            <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] < 0">$({{ studentNetBillData[item.value].toString().slice(1) }})</span> 
                                            <span v-if="(item.text != ' ' && !studentNetBillData.hasOwnProperty(item.value)) || (item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] == 0)">$0.00</span>
                                        </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <!--Year is to be entered from data-->
                                        <tr><th class="text-left" colspan="2" style="font-size: 13px;">Net Tuition Bill - Second Installment of {{ studentNetBillData['academicyear'] }}</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="item in winter_second_column"
                                            :key="item.text"
                                        >
                                        <td v-html="item.text"></td>
                                        <td> 
                                            <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] > 0">${{ studentNetBillData[item.value] }}</span> 
                                            <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] < 0">$({{ studentNetBillData[item.value].toString().slice(1) }})</span> 
                                            <span v-if="(item.text != ' ' && !studentNetBillData.hasOwnProperty(item.value)) || (item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] == 0)">$0.00</span>
                                        </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-simple-table v-else>
                        <template v-slot:default>
                            <thead>
                                <!--Year is to be entered from data-->
                                <tr><th class="text-left" colspan="2" style="font-size: 13px;">Net Tuition Bill - First Installment of {{ studentNetBillData['academicyear'] }}</th></tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in winter_first_column"
                                    :key="item.text"
                                >
                                <td v-html="item.text"></td>
                                <td> 
                                    <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] > 0">${{ studentNetBillData[item.value] }}</span> 
                                    <span v-if="item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] < 0">$({{ studentNetBillData[item.value].toString().slice(1) }})</span> 
                                    <span v-if="(item.text != ' ' && !studentNetBillData.hasOwnProperty(item.value)) || (item.text != ' ' && studentNetBillData.hasOwnProperty(item.value) && studentNetBillData[item.value] == 0)">$0.00</span>
                                </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-text>
                    <!--Disclaimers-->
                    <div style="border-style:solid; border-width: 2px; border-color:#B3E5FC; font-size: 12px; padding: 7px;">
                        <span style="font-size: 16px;"><v-icon>mdi-information-outline</v-icon>&nbsp;<b>Disclaimers</b> <br /></span>
                        1. Institutional Aid refers to scholarships, bursaries and awards provided by King's which are not required to be repaid however, 
                        are subject to terms and conditions in order to maintain eligibility. 
                        Please refer to the <a href="https://www.kings.uwo.ca/current-students/money-matters/">Money Matters section of the King's website</a>.<br />
                        2. OSAP funding received by King's and applied to your account. <br />
                        3. OSAP in Transit reflects the amount of OSAP requested by King's but not yet received. <br />
                        4. OSAP Aid Pending reflects the amount of OSAP available but not yet processed and requested by the school. <br />
                        5. If there is a negative current balance owing, this reflects OSAP aid that will be issued directly to you by the National Student Loan Centre. <br />
                        6. Actual values may vary where changes have not yet been updated on your OSAP assessment. <br />
                        7. Recent changes to your registration may not be reflected in tuition and compulsory fees and/or OSAP.
                    </div>
                </v-card-text>
            </v-card>
            <v-card elevation="0" v-else>
                <v-container style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col cols="12" class="text-subtitle-1 text-center">
                            <v-card elevation="0">
                                <span>
                                    {{ errortext }}
                                </span><br />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-row>
    </div>
</template>
<script>
import auth from '../../../js/auth.js';

export default {
    computed: {
        getUserName() {
            let user = {}
            let fullname = ""
            if(sessionStorage.getItem("sfs_asss")){
                user = JSON.parse(sessionStorage.getItem("sfs_asss"));
                fullname = user["lastname"]+", "+user["firstname"];
            }else {
                user = auth.get_user();
                fullname = user["surname"]+", "+user["name"];
            }

          return fullname;
        },
        getStudentNo(){
            let user = {}
            if(sessionStorage.getItem("sfs_asss")){
                user = JSON.parse(sessionStorage.getItem("sfs_asss"));
            }else {
                user = auth.get_user();
            }

            if(user["dev"]){
                return user["dev"]
            }else if(user["employeeNumber"]){
                return user["employeeNumber"]
            }else {
                return user["emplid"]
            }
        },
    },
    data(){
        return {
            host: location.hostname.toString(),
            secondInstallment: true,
            errorFlag: true,
            winter_first_column: [
                {"text": "Balance Carried forward first term", "value": "balancescarriedforward-term1-amount"},
                {"text": "Tuition", "value": "tuition-term1-amount"},
                {"text": "Compulsory Fees", "value": "compfees-term1-amount"},
                {"text": "Health/Dental Plan", "value": "healthdental-term1-amount"},
                {"text": "Bus Pass", "value": "buspass-term1-amount"},
                {"text": "Residence, Meal Plan", "value": "residenceandmeal-term1-amount"},
                {"text": "Other Fees", "value": "otherfees-term1-amount"},
                {"text": "Refund Cheque", "value": "refundcheque-term1-amount"},
                {"text": " ", "value": ""},
                {"text": "Payments/Credits", "value": "payments-term1-amount"},
                {"text": "Insitutional Aid <sup>1</sup>", "value": "institutionalaid-term1-amount"},
                {"text": "OSAP Payments <sup>2</sup>", "value": "osappayments-term1-amount"},
                {"text": "OSAP In Transit <sup>3</sup>", "value": "osap-intransit-term1-amount"},
                {"text": "OSAP Aid Pending <sup>4</sup>", "value": "osap-aidpending-term1-amount"},
                {"text": "Current Balance Owing <sup>5</sup>", "value": "currentbalance-term1-amount"}
            ],
            winter_second_column: [
                {"text": "Balance Carried forward second term", "value": "balancescarriedforward-term2-amount"},
                {"text": "Tuition", "value": "tuition-term2-amount"},
                {"text": "Compulsory Fees", "value": "compfees-term2-amount"},
                {"text": "Health/Dental Plan", "value": "healthdental-term2-amount"},
                {"text": "Bus Pass", "value": "buspass-term2-amount"},
                {"text": "Residence, Meal Plan", "value": "residenceandmeal-term2-amount"},
                {"text": "Other Fees", "value": "otherfees-term2-amount"},
                {"text": "Refund Cheque", "value": "refundcheque-term2-amount"},
                {"text": " ", "value": ""},
                {"text": "Payments/Credits", "value": "payments-term2-amount"},
                {"text": "Insitutional Aid <sup>1</sup>", "value": "institutionalaid-term2-amount"},
                {"text": "OSAP Payments <sup>2</sup>", "value": "osappayments-term2-amount"},
                {"text": "OSAP In Transit <sup>3</sup>", "value": "osap-intransit-term2-amount"},
                {"text": "OSAP Aid Pending <sup>4</sup>", "value": "osap-aidpending-term2-amount"},
                {"text": "Current Balance Owing <sup>5</sup>", "value": "currentbalance-term2-amount"},
            ],
            getloading: false,
            studentNetBillData: {},
            errortext: ""

        }
    },
    methods: {
        getDate(){
            const that = this;

            var today = new Date();
            var month = today.getMonth();

            if(month >= 5 && month <= 10){
                that.secondInstallment = false;
            }else {
                that.secondInstallment = true;
            }
        },
        callData(){
            const that = this;
            that.getDate();
            that.getloading = true;
            that.errorFlag = false;

            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?getdocuments&data={"emplid":"'+that.getStudentNo+'"}';

            that.studentNetBillData = {};

            fetch(api)
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.modifyData(data.data.netbill["CURRENT"][0]);
                        that.getloading = false;
                    }else {
                        that.errorFlag = true;
                        that.errortext = "No Net Bill data is available. Please contact Student Finance Services for more details.";
                        that.getloading = false;
                    }
                })
                .catch(function () {
                    that.errorFlag = true;
                    that.getloading = false;
                })
        },
        modifyData(databaseData){
            const that = this;

            if(Object.keys(databaseData).length === 0){
                that.errorFlag = true;
                that.errortext = "No Net Bill data is available. Please contact Student Finance Services for more details.";
            }else if(databaseData.hasOwnProperty("error")){
                that.errorFlag = true;
                that.errortext = databaseData["error"];
            }else {
                that.errorFlag = false;

                //Study Period && year
                if(databaseData.hasOwnProperty("applicant-studyperiodstart") && databaseData.hasOwnProperty("applicant-studyperiodend")){
                    databaseData['applicant-studyperiodstart'] = databaseData['applicant-studyperiodstart'].slice(0,4)+"/"+databaseData['applicant-studyperiodstart'].slice(4,6)+"/"+databaseData['applicant-studyperiodstart'].slice(6,8);
                    databaseData['applicant-studyperiodend'] = databaseData['applicant-studyperiodend'].slice(0,4)+"/"+databaseData['applicant-studyperiodend'].slice(4,6)+"/"+databaseData['applicant-studyperiodend'].slice(6,8);
                    databaseData['yearStart'] = databaseData['applicant-studyperiodstart'].slice(0,4);
                    databaseData['yearEnd'] = databaseData['applicant-studyperiodend'].slice(0,4);
                    databaseData['academicyear'] = databaseData['yearStart']+"-"+databaseData['yearEnd'];
                }

                //Current Balance Owing (Term 1)
                if(databaseData.hasOwnProperty("currentbalance-term1-amount") && parseFloat(databaseData["currentbalance-term1-amount"]) <= 0.00){
                    databaseData["currentbalance-term1-amount"] = 0.00;
                }

                //Current Balance Owing (Term 2)
                if(databaseData.hasOwnProperty("currentbalance-term2-amount") && parseFloat(databaseData["currentbalance-term2-amount"]) <= 0.00){
                    databaseData["currentbalance-term2-amount"] = 0.00;
                }

                that.studentNetBillData = databaseData;
            }

        }
    },
    created(){
        const that = this;
        that.callData();
    }
}
</script>
<style scoped>
    thead > tr:first-child {background-color: #E0F2F1;}
    tbody > tr:nth-child(even) {background-color: #ECEFF1;}
    tbody > tr:last-child {font-weight: bold;}
</style>